import { render } from "./MediaBuyingView.vue?vue&type=template&id=1018a861&scoped=true&ts=true"
import script from "./MediaBuyingView.vue?vue&type=script&lang=ts"
export * from "./MediaBuyingView.vue?vue&type=script&lang=ts"

import "./MediaBuyingView.vue?vue&type=style&index=0&id=1018a861&scoped=true&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1018a861"]])

export default __exports__